import { CellProps } from '~/ui/components';

export function cellToValue<TData>(props: CellProps<TData>) {
  const value = props?.getValue<number | string>();
  return value || '-';
}
